// Darrel Boye real photography assets
export const ASSETS = {
  heroPortrait:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_dboye-services/artifacts/hf3rpg9k_9C4981E2-0374-4793-B961-1CF9FBF88F5D.PNG",
  portraitLowAngle:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_dboye-services/artifacts/aatti16u_IMG_4123.webp",
  setInterrogation:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_dboye-services/artifacts/m570ihm7_IMG_7985.webp",
  setWarehouseBulbs:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_dboye-services/artifacts/vdk0ouo0_IMG_7016.webp",
  setWarehouseOp:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_dboye-services/artifacts/idk626dt_IMG_7015.webp",
  resumePdf:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_dboye-services/artifacts/fblzj7qq_Resume_2026.pdf",
};
